/**
 * Centralized API utilities for consistent header handling across all API layers.
 *
 * When in share link mode, the `x-inscope-shared-document` header is added to all requests.
 * This header tells backend middleware to:
 * 1. Validate that the user has share-based access to the document
 * 2. Override the org context to the document's org
 * 3. Enforce permission levels (viewer/commenter/editor)
 */
/**
 * Get the shared document header if in share link mode.
 * This header tells backend middleware to validate share settings and override org context.
 *
 * @returns {Object} Headers object with x-inscope-shared-document if in share link mode
 */
export const getSharedDocumentHeader = () => {
  // Lazy require keeps this module out of the `store → api-slice → apiUtils → store`
  // cycle at module load.
  const store = require('../store').default;
  const {session} = store.getState();

  if (!session.isShareLinkMode || !session.sharedDocumentOrg?.documentId) {
    return {};
  }

  return {
    'x-inscope-shared-document': session.sharedDocumentOrg.documentId,
  };
};
